<template>
  <pull-refresh
    class="style-refresh py-1"
    v-model="loading"
    @refresh="onRefresh"
    pulling-text="Pull to Refresh..."
    loosing-text="Pull to Refresh.."
    loading-text="Loading..."
    success-text="Refresh Successfully!"
  >
    <slot></slot>
  </pull-refresh>
</template>
<script>
import PullRefresh from "pull-refresh-vue3";
export default {
  name: "PullToRefresh",
  components: { PullRefresh },
  props: {
    refreshFunction: { type: Function, required: true },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onRefresh() {
      this.refreshFunction().then(() => (this.loading = false));
    },
  },
};
</script>

<style scope>
.lb-pull-refresh__track {
  min-height: 80vh;
}
</style>
